import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-required-marker',
    template: '*',
    styleUrls: ['./required-marker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class RequiredMarkerComponent {
}
